import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
import reportWebVitals from './reportWebVitals';
import VärmesystemScreen from './Varmesystem.js';
import SolcellScreen from './Solcell.js';
import Nav from './Nav.js';
import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <Nav/>
      <Routes>
        <Route path="/" element= {<SolcellScreen/>}/>
        <Route path="/varmelayout" element= {<VärmesystemScreen/>}/>
      </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
